import DatePicker from 'react-datepicker';
import React, { useEffect, useState } from 'react';
import Heading from '../../../../../generic-components/Heading';
import { refactoredTimeAndDate } from '../../../../../helpers/timeFormatter.helper';
import { DATE_FORMAT } from '../../../../../constants/general';
import Button from '../../../../../generic-components/Button';
import { ReactComponent as CalendarIcon } from '../../../../../assets/icons/svg/shared/ic-shared-calendar.svg';
import { getPriorDateFromSpecificDate, getFutureDateFromSpecificDate } from '../../../../../helpers/datesAndTime.helper';
import { DATE_PICKER_TYPES, STYLES } from '../../consts/consts';
import { useStore } from '../../../../../store';

const { INVOICE_CREATION: { INVOICE_DATES_PICKER: componentStyles } } = STYLES;

interface IProps {
    onIssueDateSelected: (date: Date, type: string) => void;
}

export const IssueDatePicker = ({ onIssueDateSelected }: IProps) => {
  const invoiceData = useStore(state => state.invoiceData);
  const initialIssueDate = invoiceData?.issueDate;
  const [selectedDate, setSelectedDate] = useState<Date>(initialIssueDate ? new Date(initialIssueDate) : new Date());
  const [isDatePickerShown, setIsDatePickerShown] = useState<boolean>(false);

  const handleDateSelected = (date: Date) => {
    setSelectedDate(date);
    setIsDatePickerShown(false);
  };

  const handleClick = () => {
    setIsDatePickerShown(!isDatePickerShown);
  };

  useEffect(() => {
    if (!selectedDate) return;
    onIssueDateSelected(selectedDate, DATE_PICKER_TYPES.ISSUE_DATE);
  }, [selectedDate]);

  return (
    <div className={componentStyles.PICKER_CONTENT_WRAPPER}>
      <Button
        childElement={(
          <div className='flex items-center'>
            <Heading
              title={
                refactoredTimeAndDate(
                  selectedDate.toDateString(),
                  'InvoiceCreation',
                  DATE_FORMAT.LETTERS,
                  false,
                )
}
              className={componentStyles.PICKER_CONTENT_HEADER}
            />
            <CalendarIcon className={componentStyles.PICKER_CONTENT_ICON} />
          </div>
        )}
        onClick={handleClick}
        className={componentStyles.PICKER_TRIGGER_BUTTON}
        id='elButtonIssueDateTrigger'
      />
      {isDatePickerShown && (
        <div className={componentStyles.FLOATING_WRAPPER_DATE_PICKER}>
          <DatePicker
            onChange={handleDateSelected}
            onClickOutside={() => setIsDatePickerShown(false)}
            selected={selectedDate}
            minDate={getPriorDateFromSpecificDate(180, new Date())}
            maxDate={getFutureDateFromSpecificDate(180, new Date())}
            dropdownMode='select'
            showMonthDropdown
            showYearDropdown
            inline
          />
        </div>
      )}
    </div>
  );
};
